import { userAuthContextType } from '../../auth/AuthProvider';
import { axios, getResponse, settings } from '../../helpers/main';

const { backend, } = settings;
const authServices = { user: userAuthContextType, }; //eslint-disable-line
const objectSerice = getResponse({ type: 0 }); //eslint-disable-line

/**
 * Service to manage communication with the DataCenters API.
 * Follows the Single Responsibility Principle (SRP) by separating network logic from the UI.
 */
export const DataCenterService = {
    /**
     * Retrieves all DataCenters and related master data (customers).
     * @param {Object} params - Query parameters.
     * @param {authServices} params.auth - User authentication object (passed from the component).
     * @param {number} params.languageId - Current language ID.
     * @param {string} [params.subMethod=''] - Sub-method name for error traceability.
     * @returns {Promise<objectSerice>} Promise with the API response.
     */
    getAll: async ({
        auth,
        languageId = 'en',
        subMethod = '',
    } = {}) => {
        const requestObj = {
            url: `${backend?.urls?.api}${backend?.urls?.apiV1}${backend?.urls?.dataCenters}/`,
            headers: {
                authorization: `bearer ${auth?.user?.token?.token}`,
            },
            data: {
                method: backend?.methods?.dataCenters.getAll,
                languageId: languageId,
            },
            subMethod: subMethod,
        };
        return await axios.post(requestObj);
    },

    /**
     * Retrieves a DataCenter by its ID.
     * @param {Object} params - Query parameters.
     * @param {authServices} params.auth - User authentication object (passed from the component).
     * @param {string} params.id - DataCenter ID.
     * @param {string} [params.languageId='en'] - Current language ID.
     * @param {string} [params.subMethod=''] - Sub-method name for error traceability.
     * @returns {Promise<objectSerice>} Promise with the API response.
     **/
    getById: async ({
        auth,
        id,
        languageId = 'en',
        subMethod = '',
    }) => {
        const requestObj = {
            headers: {
                authorization: `bearer ${auth?.user?.token?.token}`,
            },
            data: {
                id: id,
                languageId: languageId,
                method: backend?.methods?.dataCenters?.getById,
            },
            url: `${backend?.urls?.api}${backend?.urls?.apiV1}${backend?.urls?.dataCenters}/`,
            subMethod: subMethod,
        };
        return await axios?.post(requestObj);
    },
};
